/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { PostCreateDebtorTokenMutationRequest, PostCreateDebtorTokenMutationResponse, PostCreateDebtorTokenPathParams, PostCreateDebtorToken400, PostCreateDebtorToken401 } from "../../models/PostCreateDebtorToken";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getPostCreateDebtorTokenUrl({ debtorCode }: { debtorCode: PostCreateDebtorTokenPathParams["debtorCode"] }) {
  const res = { method: 'POST', url: `/api/v1/debtors/${debtorCode}/tokens` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/tokens}
 */
export async function postCreateDebtorToken({ debtorCode, data }: { debtorCode: PostCreateDebtorTokenPathParams["debtorCode"]; data: PostCreateDebtorTokenMutationRequest }, config: Partial<RequestConfig<PostCreateDebtorTokenMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PostCreateDebtorTokenMutationResponse, ResponseErrorConfig<PostCreateDebtorToken400 | PostCreateDebtorToken401>, PostCreateDebtorTokenMutationRequest>({ method : "POST", url : getPostCreateDebtorTokenUrl({ debtorCode }).url.toString(), data : requestData, ... requestConfig })  
  return res.data
}